"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCarpet = function SvgCarpet(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3.5c-.504.705-.75 1.392-.75 2.068 0 .667.24 1.307.734 1.932H20.74c.464-.696.69-1.377.69-2.048 0-.665-.223-1.313-.679-1.952H3.25zm.25 4h17v9h-17z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    d: "M5.5 7.5h13v7h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    d: "M8.364 7.537 12 11.108l3.336-3.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18v2m2-2v2m3-2v2m2-2v2m3-2v2m2-2v2m3-2v2m2-2v2",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCarpet);
var _default = exports["default"] = Memo;